import { useActivityDefinition } from "@/lib/api/activities";
import type { ConnectQuestion } from "@somethings-ui/core/connect-questions";
import { useMemo } from "react";

interface ConnectDefinition {
  staticContent: {
    version: string;
    questions: {
      count: number;
      bank: ConnectQuestion[];
    };
  };
}

export const useConnectDefinition = () =>
  useActivityDefinition<ConnectDefinition>("connect_moment");

export const useConnectQuestionBank = (): ConnectQuestion[] => {
  const { data } = useConnectDefinition();
  return useMemo(() => data?.staticContent.questions.bank ?? [], [data]);
};

export const useConnectQuestion = (
  questionId: string | undefined,
): ConnectQuestion | undefined => {
  const bank = useConnectQuestionBank();
  return useMemo(
    () =>
      questionId
        ? bank.find((question) => question.id === questionId)
        : undefined,
    [bank, questionId],
  );
};
